import { getApiKey } from "../../utils/apiKey";
import React, { Component } from "react";
import { apiCall_domain } from "../api";
import Header from "../header";
import { createGlobalStyle } from "styled-components";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import { Link } from "react-router-dom";

class TicketDetails extends Component {
  state = {
    ticketDetails: [],
    TicketDetails: true,
    loading: true,
  };
  componentDidMount() {
    const Headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };

    axios
      .get(
        `${apiCall_domain}/customer/user/tickets/${localStorage.getItem(
          "ticketDetailsIdUser",
        )}`,
        {
          headers: Headers,
        },
      )
      .then((res) => {
        this.setState({ ticketDetails: res.data.data, loading: false });
      });
  }
  render() {
    const GlobalStyles = createGlobalStyle`body{
            background: #F9F9F9;
          }`;
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <GlobalStyles />
            <Header
              showSearchBar={true}
              title={`${this.state.ticketDetails.title}`}
              TicketDetails={this.state.TicketDetails}
              is_closed={this.state.ticketDetails.is_closed}
            />
            {/* {this.state.ticketDetails.messages[0]?.pic && (
                <div className='img'>
                  <img
                    src={`${this.state.ticketDetails.messages[0]?.pic}`}
                    alt='pic'
                  />
                </div>
              )}
              <div className='text'>
                {this.state.ticketDetails.messages[0]?.text}
              </div>
              <div className='Time'>
                {this.state.ticketDetails.messages[0]?.created_at}
              </div> */}
            <div className="ticketDetails">
              {this.state.ticketDetails.messages.map((msg) => {
                if (msg.from_user === 1) {
                  return (
                    <div className="ticketDetailsMainCom clientResponse">
                      {msg.pic && (
                        <div className="img">
                          <img src={msg.pic} alt="pic" />
                        </div>
                      )}
                      <div className="text">{msg.text}</div>
                      <div className="Time">{msg.created_at}</div>
                    </div>
                  );
                } else {
                  return (
                    <div className="ticketDetailsMainCom siteResponse">
                      {msg.pic && (
                        <div className="img">
                          <img src={msg.pic} alt="pic" />
                        </div>
                      )}
                      <div className="text">{msg.text}</div>
                      <div className="Time">{msg.created_at}</div>
                    </div>
                  );
                }
              })}
            </div>
            <Link to={"/showMore/Support/ReplyTicket"} className="PostNewReply">
              <img src="/public/assets/icons/reply.svg" alt="pic" />
              <span>ارسال پاسخ جدید</span>
            </Link>
          </>
        )}
      </>
    );
  }
}
export default TicketDetails;
